import { useEffect, useState } from 'react';

import { getViewerCountryCode } from '../utils/get-viewer-geo-codes';
import { isEuCountryCode } from '../utils/is-eu-country-code';

export function useIsEUVisitor() {
  const [isEUVisitor, setIsEUVisitor] = useState(false);
  useEffect(() => {
    const viewerCountryCode = getViewerCountryCode();
    if (viewerCountryCode) {
      setIsEUVisitor(isEuCountryCode(viewerCountryCode));
    }
  }, []);
  return isEUVisitor;
}
